import { Component, Input } from '@angular/core';
import { InstanceService } from '@commonspirit/ngx-instance';
import { ConfigurationKey } from '../../../../core/models/configuration-key';

@Component({
  selector: 'fal-location-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  @Input() regionalHelplines?: { phones: { heading?: string; phone: string }[] };
  @Input() myProviders?: { link: string; target: string | undefined };
  @Input() questionsBillingInsurance?: { link: string; target: string | undefined };

  constructor(public service: InstanceService) {
    this.setRegionalHelplines();
    this.myProviders = this.setLink(ConfigurationKey.MyProviders);
    this.questionsBillingInsurance = this.setLink(ConfigurationKey.QuestionsBillingAndInsurance);
  }

  setRegionalHelplines(): void {
    const phones =
      (this.service.getConfiguration(ConfigurationKey.RegionalHelplines)?.value as { heading?: string; phone: string }[]) ?? undefined;

    if (!phones) return;

    this.regionalHelplines = {
      phones: phones
    };
  }

  setLink(key: string): { link: string; target: string | undefined } | undefined {
    const value = (this.service.getConfiguration(key)?.value as { link: string; target: string | undefined }) ?? undefined;
    if (!value) {
      return;
    }

    return value;
  }
}
